/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RiskScoreRiskScoreName
 */
export interface RiskScoreRiskScoreName {
    /**
     * 
     * @type {string}
     * @memberof RiskScoreRiskScoreName
     */
    tc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RiskScoreRiskScoreName
     */
    value?: string | null;
}

export function RiskScoreRiskScoreNameFromJSON(json: any): RiskScoreRiskScoreName {
    return RiskScoreRiskScoreNameFromJSONTyped(json, false);
}

export function RiskScoreRiskScoreNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskScoreRiskScoreName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tc': !exists(json, 'tc') ? undefined : json['tc'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function RiskScoreRiskScoreNameToJSON(value?: RiskScoreRiskScoreName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tc': value.tc,
        'value': value.value,
    };
}


